import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { useMemo } from 'react';
import v4 from 'uuid';
import ProffitSearchLandingPageSecurity from './ProffitSearchLandingPageSecurity';
const ProffitSearchLandingPageSecuritiesBody = () => {
    const list = useMemo(() => _.chunk([
        {
            description: 'PROFFIT SEARCHの利用依頼をした際には、会社のメールへユニークなURLを送り、利用依頼のあったブラウザと、URLをクリックしたブラウザが同じ場合のみ、情報へのアクセスが可能になっています。\n新しいブラウザのご利用が確認された際には、再度同じ手順でログインをしていただきます。（PC以外の端末ではご利用いただけません）\nこの仕組みにより、PROFFIT SEARCHでは、社外端末からのアクセスを制限し、スライドの個人利用・流出を防ぎます。',
            title: '社外端末からのアクセス制限',
        },
        {
            description: 'お客様とPROFFIT SEARCHとの通信は最新 TLS1.2 以上に限定し、暗号化されております。\n通信における盗聴や傍受、改ざんやなりすましのリスクに対応しております。',
            title: '暗号化通信',
        },
        {
            description: 'アップロードされたファイルは暗号化して保存されており（AESによる暗号化）、第三者によるデータの読み取りを防ぎます。',
            title: '保存ファイルの暗号化',
        },
        {
            description: '外部のネットワークからの攻撃や不正なアクセスからデータの機密を保護するために、WAF / ファイアウォール により機密情報をインターネットから隔離して保管しています。',
            title: 'ファイアウォール',
        },
        {
            description: 'パスワード設定時に短いパスワードや推測されやすいパスワードが登録できないようパスワード強度のチェックを行っております。またパスワード認証に加えて2要素認証を設定することが可能です。\nお客さま自身でも、アカウントを守るため、他で使用しておらず、簡単に推測できないパスワードを作成してください。',
            title: 'アカウント保護',
        },
        {
            description: 'インターネットからの攻撃を24時間常時監視しています。万が一、不測の事態が発生する場合でも即時に対応できる体制をとっています。',
            title: '24時間セキュリティ監視・アクティビティ監視',
        },
    ], 3).map((v) => ({ key: v4(), list: v })), []);
    return (_jsx("div", Object.assign({ className: 'proffit_search_landing_page_securities_body' }, { children: _jsx("div", Object.assign({ className: 'body_inner' }, { children: list.map((v) => (_jsx("ul", Object.assign({ className: 'body_list' }, { children: v.list.map((item) => (_jsx(ProffitSearchLandingPageSecurity, { item: item }, item.title))) }), v.key))) })) })));
};
export default ProffitSearchLandingPageSecuritiesBody;
